import { Box } from "@mui/material";
import React, { useState } from "react";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { CircularProgress, Stack } from "@mui/material";

// import "./phoneInput.styles.css";
// import "react-phone-number-input/style.css";

import { API, Auth } from "aws-amplify";
import { useSelector } from "react-redux";
import { authData } from "../../redux/auth/authSlice";
import CustomInput from "../../components/CustomInput/CustomInput";
import { HeadingPrimary } from "../../components/Styles/Heading";
import {
  displayCenter,
  inputBoxStyle,
  inputIconStyle,
} from "../../components/SignInAndSignUp/SignInAndSignUp";

import { useHistory, useLocation } from "react-router-dom";
import CustomLoginLayout from "./CustomLoginLayout";
import { CustomButton } from "../../components/CustomButton/CustomButton";
import { useDispatch } from "react-redux";
import { useQueryParams } from "../../Hooks/useQueryParams";
import config from "../../aws-exports";
import { awsSignIn } from "../../redux/auth/authSlice";
const SignUpONDC = () => {
  const userDetails = useSelector(authData);
  const location = useLocation();
  const history = useHistory();

  const query = useQueryParams();

  const dispatch = useDispatch();
  const [code, setCode] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [resendLoad, setResendLoad] = useState(false);

  async function confirmSignUp(e) {
    if (code.length === 0) {
      setErrors({ code: "Please enter the code" });
    } else {
      setErrors({ code: "" });
    }

    e.preventDefault();
    setBtnLoading(true);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let username = userdata?.username;

    try {
      const jsonString = JSON.stringify({
        otp: code,
          emailid: username,
          schema: config.schema
      });
      const base64EncodedString = btoa(jsonString);
      const bodyParam = {
        body: {
          json:base64EncodedString
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: userDetails?.accessToken	
        },
      };

      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/userConfirmSignUp",
        bodyParam
      );
      if (response.statusCode === 200) {
        let res = response?.body?.data;
        let body = {
          id: res.eid,
          username: res.uid,
          name: res?.first_name + " " + res?.last_name,
          emailid: res.emailid,
          email: res.emailid,
          locale: res.oid,
          tenant: res.oid,
          uData: {
            ...res,
          },
        };
        localStorage.removeItem("userdata");
        localStorage.setItem("userdata", JSON.stringify(body));
        body.location = {};
        checkEmailConfirmed(body);
      } else {
        setErrors({});
        setBtnLoading(false);
        return setErrors((prev) => ({
          ...prev,
          code: response?.body?.message,
        }));
      }
    } catch (err) {
      setBtnLoading(false);
      console.error(err);
      throw err;
    }
  }
  async function analyticsWebApp(userDetails) {
    const data = {
      oid: config.aws_org_id,
        eventtype: "AuthenticatedViaCognito",
        id: userDetails.id,
        iid: config.aws_cognito_identity_pool_id,
        email: userDetails.email,
        name: userDetails.name,
        emailid: userDetails.emailid,
        tenant: userDetails.locale,
        ur_id: userDetails.uData?.ur_id,
        schema: config.schema
    }
    
    data.emailid = userDetails.emailid;
    const jsonString = JSON.stringify(data);
    const base64EncodedString = btoa(jsonString);
    const bodyParam = {
      body: {
        json:base64EncodedString
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: userDetails?.accessToken	
      }
    };

    try {
      await API.post(
        config.aws_cloud_logic_custom_name,
        "/analyticsWebApp",
        bodyParam
      );


    
      dispatch(awsSignIn(userDetails));
      let id = query.get("id");
      if (location.pathname === "/course" && id) {
        history.push(`/course?id=${id}`);
      } else if (location.pathname === "/content" && id) {
        history.push(`/content?id=${id}`);
      } else {
        history.push("/home");
      }
      setBtnLoading(false);
    } catch (err) {
      console.error(err);
    }

    // window.location.href = homeurl;
  }

  const checkEmailConfirmed = async (body) => {
    let userCred = JSON.parse(localStorage.getItem("userCred"));

    try {
      const user = await Auth.signIn(userCred.emailid, userCred.password);

      analyticsWebApp(body);
    } catch (error) {
      console.error(error);

      const code = error.code;

      if (code === "UserNotConfirmedException") {
        history.push({
          pathname: "/",
          state: { username: userCred.emailid },
        });
      }
    }
  };

  async function resendConfirmationCode() {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let username = userdata?.username;

    const jsonString = JSON.stringify({
      emailid: username,
          schema: config.schema
    });
    const base64EncodedString = btoa(jsonString);
    try {
      const bodyParam = {
        body: {
          json:base64EncodedString
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: userDetails?.accessToken	
        },
      };

      setResendLoad(true);
      const res = await API.post(
        config.aws_cloud_logic_custom_name,
        "/userResendOtp",
        bodyParam
      );
      if (res.statusCode === 200) {
      } else {
        setErrors({});
        setErrors((prev) => ({ ...prev, code: res?.body?.message }));
      }
      setResendLoad(false);
    } catch (err) {
      setResendLoad(false);
    }
  }

  return (
    <React.Fragment>
      <CustomLoginLayout>
        <Box sx={{ textAlign: "center" }}>
          <HeadingPrimary>Confirm code</HeadingPrimary>
        </Box>

        <form
          onSubmit={confirmSignUp}
          noValidate
          autoComplete="off"
          style={displayCenter}
        >
          <React.Fragment>
            <Box component="div" sx={inputBoxStyle}>
              <CustomInput
                id="input-confirmPassword"
                placeholder="Enter the Verification Code sent to your phone"
                type="text"
                name="code"
                value={code}
                error={errors.code}
                onChange={(e) => {
                  setCode(e.target.value);
                }}
              >
                <LockOutlinedIcon sx={inputIconStyle} />
              </CustomInput>
              <Stack direction="row" justifyContent="flex-end">
                <button
                  style={{
                    fontSize: "1.4rem",
                    textAlign: "right",
                    cursor: "pointer",
                    fontFamily: `myfontregular`,
                    background: "transparent",
                    border: 0,
                  }}
                  type="button"
                  onClick={resendConfirmationCode}
                  disabled={resendLoad}
                >
                  Resend
                </button>
              </Stack>
            </Box>
            <Box component="div" sx={{ textAlign: "center", mb: 3 }}>
              <CustomButton
                type="button"
                onClick={() => {
                  history.push("/");
                }}
              >
                Back
              </CustomButton>
              {btnLoading ? (
                <CustomButton disabled loading="true">
                  <CircularProgress color="inherit" size={20} />
                </CustomButton>
              ) : (
                <CustomButton type="submit" primary>
                  Submit
                </CustomButton>
              )}
            </Box>
          </React.Fragment>
        </form>
      </CustomLoginLayout>
    </React.Fragment>
  );
};

export default SignUpONDC;
